import { Menu, type MenuGroupProps, Text } from "@overmap-ai/blocks"
import type { AssetTypeStatus, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { AssetTypeStatusIcon } from "../Icons/AssetTypeStatusIcon"

export interface AssetTypeStatusGroupProps extends MenuGroupProps {
	assetTypeStatuses: Stored<AssetTypeStatus>[]
	onSelectAssetTypeStatus: (assetTypeStatus: Stored<AssetTypeStatus>) => void
}

export const AssetTypeStatusGroup = memo<AssetTypeStatusGroupProps>((props) => {
	const { ref, assetTypeStatuses, onSelectAssetTypeStatus, ...rest } = props

	return (
		<Menu.Group ref={ref} {...rest}>
			{assetTypeStatuses.map((assetTypeStatus) => (
				<Menu.Item key={assetTypeStatus.uuid} onSelect={() => onSelectAssetTypeStatus(assetTypeStatus)}>
					<AssetTypeStatusIcon assetTypeStatusId={assetTypeStatus.uuid} />
					<Text className="truncate">{assetTypeStatus.name}</Text>
				</Menu.Item>
			))}
		</Menu.Group>
	)
})
AssetTypeStatusGroup.displayName = "AssetTypeStatusGroup"
